export const imageUrl = process.env.NEXT_PUBLIC_IMG_URL;
export const paramsJoiner = '/';

type ResizingType = 'fit' | 'fill' | 'fill-down' | 'force' | 'auto';

interface ICustomImageProperties {
    width: number;
    height: number;
    type?: ResizingType;
}

export const getImageUrl = (imagePath: string, customImageProperties?: ICustomImageProperties) => {
    if (!customImageProperties) {
        return `${imageUrl}/${imagePath}`;
    }

    const { width, height, type = 'fit' } = customImageProperties;

    const combinedSize = `${width}x${height}`;
    const allProperties = [type, combinedSize];
    const combinedProperties = allProperties.join(paramsJoiner);

    return `${imageUrl}/${combinedProperties}/${imagePath}`;
};
